import { render, staticRenderFns } from "./Lineups.vue?vue&type=template&id=6f96f098&scoped=true&"
import script from "./Lineups.vue?vue&type=script&lang=js&"
export * from "./Lineups.vue?vue&type=script&lang=js&"
import style0 from "./Lineups.vue?vue&type=style&index=0&id=6f96f098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f96f098",
  null
  
)

export default component.exports